import React, { VFC } from 'react'
import styled from 'styled-components'

import { AccordionSidePane } from '@Components/CMS/AccordionSidePane'
import { Title } from '@Components/CMS/Title'
import { ShippingInfoWrapper } from '@Components/Shipping/ShippingInfo'
import { ShippingIntro } from '@Components/Shipping/ShippingInfoModal/Intro'
import { ShippingOptions } from '@Components/Shipping/ShippingInfoModal/Options'
import { ShippingPolicy } from '@Components/Shipping/ShippingInfoModal/Policy'
import { ShippingToCountry } from '@Components/Shipping/ShippingInfoModal/ToCountry'
import { ShippingPricing } from '@Components/Shipping/ShippingPricing'
import useShippingLabels from '@Components/Shipping/useShippingLabels'
import { useMParticle } from '@Globals/MParticle/useMParticle'
import { Experiment } from '@Globals/SplitTests/Experiment'
import { up } from '@Globals/Style/breakpoints'
import { useTranslation } from '@Globals/Translations'

const StyledAccordionSidePane = styled(AccordionSidePane)(({ theme }) => `
    border-bottom: 5px solid ${theme.colors.greyLightest};
    ${up('mobileStyleThreshold')} {
      border-bottom: 1px solid ${theme.colors.greyLighter};
    }
`)

export const ProductShippingAndReturn: VFC = () => {
  const { data } = useShippingLabels()
  const { t } = useTranslation()
  const { otherEvent } = useMParticle()

  return (
    <StyledAccordionSidePane
      header={t('products:PP_SHIPPING_AND_RETURN')}
      onOpen={() => {
        otherEvent({
          eventName: 'delivery_details_overlay_open',
          attributes: {
            source_id: 'accordion_button',
          },
        })
      }}
    >
      <ShippingInfoWrapper>
        <Title title={t('header:SHIPPING_OPTIONS')} type="h3" />
        <ShippingToCountry />
        <Experiment
          A={(
            <>
              <ShippingIntro />
              <ShippingOptions options={data || []} />
              <ShippingPolicy />
            </>
          )}
          B={(
            <>
              <ShippingPricing showFreeShippingDescription />
              <ShippingPolicy center />
            </>
          )}
          test="visualize_free_shipping_discount_v1"
        />
      </ShippingInfoWrapper>
    </StyledAccordionSidePane>
  )
}
